var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-type-selector"},[_c('div',{staticClass:"module-type-grid"},_vm._l((_vm.moduleTypes),function(type){return _c('div',{key:type.value,staticClass:"module-type-item",on:{"click":function($event){return _vm.selectType(type)}}},[_c('i',{class:type.icon}),_c('span',[_vm._v(_vm._s(type.label))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }